import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import { useRouter } from "next/router"
import qs from "qs"
import { useTranslation } from "next-i18next"

import usePdpi18n from "@/i18n/usePdpi18n"
import { getETACached, getStock } from "@/utils/cart"
import { addToCompareProduct } from "@/utils/product"
import { removeFromCompareProduct } from "@/utils/product"
import { getConfig } from "@/constants/config"
import {
  getLocationByCookies,
  getPDPUrl,
  getShortenedUrl,
  getShortenedUrlwithGeneral,
  getUserPersona,
  showNewBadge,
} from "@/utils/helper"
import CONSTANTS, { SWATCH_NA } from "@/constants/index"
import {
  checkProductCategory,
  getShippingLocations,
  getZipCodeJsonFile,
} from "@/components/ProductDetail/v3/productDetailsHelper"
import {
  addToCart as addToCartFunc,
  attachWarehouseData,
} from "@/components/ProductDetail/v3/AddToCart/utils"

import {
  getGenericListPath,
  getstateList,
  selectGenericState,
  showPreviewCart,
  showToast,
} from "@/store/features/genericSlice"
import { apim } from "@/constants/api"
import { selectAuthState } from "@/store/features/authSlice"
import { selectCartState } from "@/store/features/cartSlice"
import {
  getDiscontinuedProductValue,
  getPdpTooltip,
  getProductBySlug,
  getProductBySlugAndSku,
  getReqItemLwData,
  getVariantFields,
  searchPdp,
  setPDP,
  setProductId,
  setProductInfo,
  setReviewDetails,
} from "@/store/features/pdpSlice"
import { compareState } from "@/store/features/compareSlice"
import { selectFavoritesState } from "@/store/features/favoritesSlice"

import ProductDetailView from "@/components/ProductDetail/v3/ProductDetailView"
import PDPLoader from "@/components/ProductDetail/v3/PDPLoader"

import MissingImage from "@/public/images/image-missing.png"
//import { cartPrerender } from "@/utils/prerender"
import { initBuyNow } from "./helper"
import { productSections } from "@/utils/constants"
import {
  getProductBySkus,
  getProductDataFromSkuIds,
  getProductInventory,
} from "@/components/Shared/UpsellInstallServices/api"
import { getPincode } from "@/components/cart/cartHelper"
import Modal from "@/components/core/Modal/Modal"
import UpsellServicesMobile from "@/components/Shared/UpsellInstallServices/UpsellServicesMobile"
import axios from "axios"
import { getDetailsFromZipCode, getLocationFromIP } from "@/utils/findStore"
import useWindowResize from "@/hooks/useWindowResize"
import { addAnalyticsForClosingRecommendedModal } from "@/components/Shared/UpsellInstallServices/analytics"
import { validNumber } from "@/utils/validate"

const ProductDetail = ({
  data: authorData = {},
  pdpData = {},
  slug = "",
  skuId = "",
  initialImgAlt = "",
  initialImgUrl = "",
}) => {
  const [width] = useWindowResize()
  const dispatch = useDispatch()
  const router = useRouter()
  const { t } = useTranslation("pdp")
  const { stateListPath } = useSelector(selectGenericState)
  const { access_token: accessToken } = useSelector(selectAuthState)
  const { cart, cart: { id: cartLoaded = "" } = {} } =
    useSelector(selectCartState)
  const {
    comparedProducts,
    category: productCategory,
    isEnable,
  } = useSelector(compareState)
  const {
    ProductBrandName_s: pdpBrnadName = "",
    productName_s: productNameInit = "",
    ProductLocalCategory_s = "",
    category1_s: productRoom = "",
  } = pdpData
  const isParts = false
  const productName = isParts ? productNameInit : pdpBrnadName

  const blankState = {
    isProductVariantClicked: false,
    clickedProductVariant: false,
    selectedSku: "",
    customerFacingSKU: "",
    productDetailData: pdpData ? pdpData : {},
    docId: "",
    fusionQueryId: "",
    masterSku: "",
    options: {},
    facetLabels: [],
    currOptions: {},
    selectMoreTooltipData: {},
    reqCartData: [],
    ctData: {},
    persona: "",
    toaster: { show: false, message: "", mobileOnly: false },
    reverseGeo: "",
    jsonFileUrl: "",
    zipCodeData: [],
    installationData: [],
    designServiceData: [],
    servicesData: {},
    installationDataFromProp: [],
    designServiceDataFromProp: [],
    availableStock: 1,
    promoTitle: null,
    promoDescription: false,
    enablePromo: false,
    viewLoader: true,
    ctLoading: true,
    findInstallerPath: "",
    loadShowEvent: false,
    installerArea: "",
    statesData: [],
    mboxes: [],
    imageClickCounter: 1,
    variantData: [],
  }
  const compare = useSelector(compareState)

  const { favorites } = useSelector(selectFavoritesState)

  const [config, setConfig] = useState({})
  const [state, setState] = useState(blankState)
  const [reviews, setReviews] = useState(null)
  const [brandName, setBrandName] = useState("")
  const [locale, setLocale] = useState("")
  const [currencySign, setCurrencySign] = useState("")
  const [currencyCode, setCurrencyCode] = useState("")
  const [cartUrl, setCartUrl] = useState("")
  const [findProPagePath, setFindProPagePath] = useState("")
  const [findStoreUrl, setFindStoreUrl] = useState("")
  const [badgeText, setBadgeText] = useState({})
  const [superSku, setSuperSku] = useState("")
  const [category, setCategory] = useState(ProductLocalCategory_s)
  const [brandNameDisplay, setBrandNameDisplay] = useState("")
  const [collapseBrandNameDisplay, setCollapseBrandNameDisplay] = useState(null)
  const [availableColorFirstSku, setAvailableColorFirstSku] = useState("")
  const [productServices, setProductServices] = useState("")
  const [name, setName] = useState(productName)
  const [pdprops, setPdprops] = useState({})
  const [comboSku, setComboSku] = useState([])
  const [isFragile, setIsFragile] = useState(false)
  const [general, setGeneral] = useState(null)
  const [imagesData, setImagesData] = useState([])
  const [videoIds, setVideoIds] = useState([])
  const [pricesData, setPricesData] = useState([])
  const [listPrices, setListPrices] = useState([])
  const [discountedPrices, setDiscountedPrices] = useState([])
  const [discountPercent, setDiscountPercent] = useState([])
  const [isType, setIsType] = useState([])
  const overSizedType = "4"
  const [badgesProps, setBadgesProps] = useState([])
  const [excludedStates, setExcludedStates] = useState([])
  const [presetConfigObject, setPresetConfigObject] = useState({})
  const [partReplacementSuggestions, setPartReplacementSuggestions] = useState(
    []
  )
  const [assetAccountName, setAssetAccountName] = useState("")
  const [homePagePath, setHomePagePath] = useState("/")
  const [replaceAddToCartCtaLink, setReplaceAddToCartCtaLink] = useState("")
  const [isPdpPropsLoaded, setIsPdpPropsLoaded] = useState(false)
  const [atcLoading, setAtcLoading] = useState(false)
  const [upSellData, setUpSellData] = useState([])
  const [inventoryUpdate, setInventoryUpdate] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [ToasterMssg, setToasterMessage] = useState("")
  const stopATCLoading = new Event("stop-loading-atc")
  const [isMobile, setIsMobile] = useState(width < 992)
  const [pincode, setPincode] = useState(null)
  const [buyNowLoading, setBuyNowLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("")
  useEffect(() => {
    setIsMobile(width < 992)
    if (width < 992) setShowModal(false)
  }, [width])
  const staticTexts = usePdpi18n(authorData, badgeText, name)

  const getRecommendationsArray = async () => { 
      const recommendations = await getProductBySkus(
        [state.selectedSku],
        "sku_s,CrossSellRecommendationSKUList_ss"
      )
      const listOfRequiredSkus = recommendations
        .filter(item => item.CrossSellRecommendationSKUList_ss)
        .map(item => ({
          parentSku: item.sku_s,
          requiredSkus: item.CrossSellRecommendationSKUList_ss,
        }))

      const requiredSkus = listOfRequiredSkus
        .map(item => item.requiredSkus)
        .flat(1)
      // Executing second API...
      const { data = {} } =
        (await getProductDataFromSkuIds(state.persona, requiredSkus)) ?? {}

      const skuidString = requiredSkus.join(",")
      if (!_isEmpty(data) && skuidString) {
        const { response: { docs: requiredSkusProductData = [] } = {} } = data

        if (requiredSkusProductData.length) {
          const item = listOfRequiredSkus[0]

          const requiredItemsProductData = requiredSkusProductData.filter(
            productItem => item.requiredSkus?.includes(productItem.sku_s)
          )
          setUpSellData(requiredItemsProductData)
        }
      }
  }

  useEffect(() => {
    getConfig().then(async res => {
      setConfig(res)
    })
  }, [])

  

  useEffect(() => {
    let pdpPropsLoadedTimer
    if (!_isEmpty(pdprops)) {
      pdpPropsLoadedTimer = setTimeout(() => {
        setIsPdpPropsLoaded(true)
      }, 1000)
    }

    return () => {
      if (pdpPropsLoadedTimer) {
        clearTimeout(pdpPropsLoadedTimer)
      }
    }
  }, [pdprops])

  useEffect(() => {
    getServiceData()
    setSuperSku("")
    setBrandNameDisplay("")
    setCollapseBrandNameDisplay(null)
    setAvailableColorFirstSku("")
    setProductServices("")
    setComboSku([])
    setImagesData([])
    setVideoIds([])
    setPricesData([])
    setListPrices([])
    setDiscountedPrices([])
    setDiscountPercent([])
    setIsType([])
    setBadgesProps([])
    setExcludedStates([])
    setPartReplacementSuggestions([])
  }, [slug])

  useEffect(() => {
    if (accessToken) {
      const persona = getUserPersona()
      setState(prevState => {
        return { ...prevState, persona: persona }
      })
    }
  }, [accessToken, slug])

  useEffect(() => {
    if (!stateListPath) {
      dispatch(getGenericListPath())
    } else {
      dispatch(getstateList())
        .unwrap()
        .then(res =>
          setState(prevState => {
            return { ...prevState, statesData: res }
          })
        )
    }
  }, [stateListPath])

  useEffect(() => {
    const url = new URL(window.location.href)
    if (skuId && !url.searchParams.get("skuNumber")) {
      setState(prevState => {
        return { ...prevState, selectedSku: skuId }
      })
    }
  }, [skuId])
  useEffect(()=>{
    if(state.selectedSku!="")
    getRecommendationsArray()
  },[state.selectedSku])
  useEffect(() => {
    if (!_isEmpty(config)) {
      setGeneral(config?.general)
      setBrandName(config.general?.siteName ?? "")
      setLocale(_get(config, "internationalization.locale", ""))
      setCurrencySign(_get(config, "internationalization.currencySign", ""))
      setCurrencyCode(_get(config, "internationalization.currencyCode", ""))
      setCartUrl(
        getShortenedUrlwithGeneral(
          config.general.cartLandingPagePath,
          config.general
        )
      )
      setFindProPagePath(
        getShortenedUrlwithGeneral(
          _get(config, "general.findProPagePath", "/"),
          config?.general
        )
      )
      setFindStoreUrl(
        getShortenedUrlwithGeneral(
          _get(_get(config, "general.findStorePagePath", ""), config?.general)
        )
      )
      setHomePagePath(
        getShortenedUrlwithGeneral(
          config?.general?.homepageUrl ?? "/",
          config?.general
        )
      )
      setBadgeText({
        new: _get(config, "general.newBadgeName", ""),
        onSale: _get(config, "general.saleBadgeName", ""),
        exclusive: _get(config, "general.exclusiveBadgeName", ""),
        discontinued: _get(config, "general.discontinuedBadgeName", ""),
      })
      setState(prevState => {
        return {
          ...prevState,
          reverseGeo: _get(config, "apiEndpoints.reverseGeo", ""),
        }
      })
      setAssetAccountName(_get(config, "general.scene7AccountName", "PAWEB"))
    }
  }, [config])

  useEffect(() => {
    if (!_isEmpty(authorData) && !_isEmpty(general)) {
      setReplaceAddToCartCtaLink(
        getShortenedUrlwithGeneral(authorData?.replaceAddToCartCtaLink, general)
      )
      const { presetConfigs = "{}" } = authorData ?? { presetConfigs: "{}" }
      const presetConfigObject = JSON.parse(presetConfigs)
      setPresetConfigObject(presetConfigObject)
    }
  }, [authorData, general])

  useEffect(() => {
    if (brandName && accessToken) {
      try {
        const payload = {
          slug,
          isParts,
          brandName,
          selectedSku: state.selectedSku,
          setSkuVariantCb: initSku => setSkuVariant(initSku),
        }
        // Get product data from LucidWorks
        dispatch(searchPdp(payload))
          .unwrap()
          .then(res => {
            if (res) {
              const {
                productData = {},
                sku = "",
                fusionQueryId = "",
                customerFacingSKU = "",
              } = res
              // set product category
              setCategory(
                _get(productData, "Product_Category", "Service Parts")
              )
              setProductServices(_get(productData, "ProductServices_ss", ""))
              // get product options
              if (
                productData["ProductIsRetail"] !== "true" &&
                productData["ProductBrandNameDisplay_s"] &&
                productData["Product_Category"]
              ) {
                setSuperSku(productData["Super_Sku"])
                setBrandNameDisplay(
                  productData["ProductBrandNameDisplay_s"] ?? ""
                )
                // adding new filter in get options.
                if (productData["Collapse_Field_s"]) {
                  setCollapseBrandNameDisplay(productData["Collapse_Field_s"])
                } else {
                  setCollapseBrandNameDisplay(null)
                }
              }

              setState(prevState => {
                return {
                  ...prevState,
                  productDetailData: productData,
                  selectedSku: sku,
                  customerFacingSKU: customerFacingSKU,
                  masterSku: _get(productData, "masterSKU_s", ""),
                  fusionQueryId: fusionQueryId,
                }
              })

              window.addEventListener("popstate", () => {
                fetchSkuFromUrl()
              })

              setState(prevState => {
                return {
                  ...prevState,
                  viewLoader: false,
                }
              })
            } else {
              console.error("Error occured while fetching product data")
            }
          })
      } catch (error) {
        console.error(error)
      }

      if (authorData) {
        const {
          promoConfigTitle = "",
          promoConfigDesc = "",
          enablePromo = "",
          installServices = [],
          designServices = [],
          findAnInstaller,
          installerArea,
          mboxIdList = [],
        } = authorData

        setState(prevState => {
          return {
            ...prevState,
            promoTitle: promoConfigTitle,
            promoDescription: promoConfigDesc,
            enablePromo,
            installationDataFromProp: installServices,
            designServiceDataFromProp: designServices,
            jsonFileUrl: installServices[0]?.jsonPath ?? "",
            findInstallerPath: findAnInstaller,
            installerArea,
            mboxes: mboxIdList,
          }
        })
      } else {
        // Get product data from CommerceTools
        const payload = {
          slug,
        }
        dispatch(getProductBySlug(payload))
          .unwrap()
          .then(product => {
            if (product.id)
              setState(prevState => {
                return { ...prevState, ctData: product }
              })
          })
      }
    }
  }, [brandName, accessToken, slug])

  useEffect(() => {
    if (pdpData) {
      setState(prevState => {
        return { ...prevState, productDetailData: pdpData, viewLoader: false }
      })
    }
  }, [pdpData])

  useEffect(() => {
    if (state.promoTitle !== null) {
      getServiceData()
      getZipCodeJsonFile(state.jsonFileUrl, data => {
        const { zipcode = [] } = data
        setState(prevState => {
          return {
            ...prevState,
            zipCodeData: zipcode,
          }
        })
      })
    }
  }, [state.promoTitle])

  useEffect(() => {
    const { productDetailData } = state
    const name = isParts
      ? _get(productDetailData, "productName_s", "")
      : _get(productDetailData, "ProductBrandName_s", "")
    setName(name)
  }, [state.productDetailData])

  useEffect(() => {
    if (!_isEmpty(state.productDetailData)) {
      let imagesData = []
      let videoIds = []
      const pricesData = []
      const listPrices = []
      let colorsData = []
      let variants = []
      let colors = []
      const comboSku = []
      const discountedPrices = []
      const discountPercent = []
      let requiredItemstoInstall = []
      const availableColors = []
      const disContinuedColors = []
      const customerSkus = []
      const isType = []
      const partReplacementSuggestions = []
      // get list of variants
      if (state.productDetailData["variantList.sku_s"]) {
        variants = [state.productDetailData["variantList.sku_s"]]
      } else if (state.productDetailData["variantList.sku_ss"]) {
        variants = state.productDetailData["variantList.sku_ss"]
      }
      // get list of variant colors
      if (state.productDetailData["Color.SKU.Details_ss"]) {
        colors = state.productDetailData["Color.SKU.Details_ss"].map(color => {
          const d = color.split("|")
          return {
            name: d[0],
            swatch: d[1],
            sku: d[2],
            isStock: d[3],
            discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
            customerSku: d[5],
          }
        })
      } else if (state.productDetailData["Color.SKU.Details_s"]) {
        const d = state.productDetailData["Color.SKU.Details_s"].split("|")
        colors = [
          {
            name: d[0],
            swatch: d[1],
            sku: d[2],
            isStock: d[3],
            discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
            customerSku: d[5],
          },
        ]
      } else if (state.productDetailData["SKU.Details_ss"]) {
        colors = state.productDetailData["SKU.Details_ss"].map(color => {
          const d = color.split("|")
          return {
            name: staticTexts.notApplicable,
            swatch: SWATCH_NA,
            sku: d[0],
            isStock: d[1],
            discontinued: !(d[2] === "false" || Date.parse(d[2]) > Date.now()),
            customerSku: d[3],
          }
        })
      }
      // get required items to install
      if (state.productDetailData["RequiredAccessoryGroupProduct_ss"]) {
        requiredItemstoInstall =
          state.productDetailData["RequiredAccessoryGroupProduct_ss"]
      }
      // get Youtube Url's
      // if (
      //   state.productDetailData[
      //     "ProductResource.YouTubeInstallVideo.resourceName_ss"
      //   ]
      // ) {
      //   videoIds = state.productDetailData[
      //     "ProductResource.YouTubeInstallVideo.resourceName_ss"
      //   ].map(v => ({ type: "video", url: v }))
      //   setVideoIds(videoIds)
      // }
      // get video with position
      if (state.productDetailData["productVideos.labelWithUrl_ss"]) {
        let videoIds = state.productDetailData[
          "productVideos.labelWithUrl_ss"
        ].map(v => ({
          type: "video",
          url: v?.split("|")[0],
          order: v?.split("|")[3],
        }))
        setVideoIds(prevState => [...prevState, ...videoIds])
      }
      if (cart.lineItems && cart.lineItems.length > 0) {
        cart.lineItems
          .filter(item => item.productSlug["en-US"] === slug)
          .map(product => {
            if (product.discountedPrice) {
              discountedPrices[product.variant.sku] = Number(
                (product.discountedPrice.value.centAmount / 100).toFixed(2)
              )
              setDiscountedPrices(discountedPrices)
              let percentOff
              if (
                product?.discountedPrice?.includedDiscounts[0]?.discount?.obj
                  ?.value?.type === "absolute"
              ) {
                percentOff = _get(
                  product.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.money[0].centAmount",
                  0
                )
                isType[product.variant.sku] = "absolute"
                setIsType(isType)
              } else {
                percentOff = _get(
                  product.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.permyriad",
                  0
                )
                isType[product.variant.sku] = "relative"
                setIsType(isType)
              }
              discountPercent[product.variant.sku] =
                percentOff > 0 ? Number(percentOff / 100) : 0
              setDiscountPercent(discountPercent)
            }
          })
      }
      // get data related to each color variant
      colors.forEach(color => {
        const colorObj = {
          id: color.sku,
          name: "product-color",
          value: color.sku,
          label: color.name,
          notApplicable:
            colors.length > 1
              ? false
              : color.swatch.toLowerCase() === SWATCH_NA.toLowerCase(),
          colorUrl: CONSTANTS.COLOR_FILE_URL + color.swatch,
          checked: color.sku === state.selectedSku ? true : false,
          discontinuedColor: color.discontinued,
        }
        color.discontinued
          ? disContinuedColors.push(colorObj)
          : availableColors.push(colorObj)
        customerSkus[color.sku] = color.customerSku
      })
      const isDisContinuedColor = colors.find(
        color => color.sku === state.selectedSku
      )?.discontinued
      colorsData = [...disContinuedColors, ...availableColors]
      if (availableColors && availableColors[0])
        setAvailableColorFirstSku(availableColors[0].id ?? "")
      const variantImages = state.productDetailData[
        "productImages.labelWithUrl_s"
      ]
        ? [state.productDetailData["productImages.labelWithUrl_s"]]
        : state.productDetailData["productImages.labelWithUrl_ss"]
      let variantImageLabels = []
      let variantImageURLs = []
      if (state.selectedSku) {
        if (variantImages?.length) {
          const selVarImageUrls = []
          const selVarImageLabels = []
          variantImages.map(img => {
            const imgDetail = img.split("|")
            if (state.selectedSku === imgDetail[0]) {
              selVarImageLabels.push(imgDetail[4] ?? "")
              selVarImageUrls.push(
                imgDetail[imgDetail.length - 1]
                  ? imgDetail[imgDetail.length - 1]
                  : MissingImage?.src
              )
            } else if (!variants.find(v => v === imgDetail[0])) {
              variantImageLabels.push(imgDetail[4] ?? "")
              variantImageURLs.push(
                imgDetail[imgDetail.length - 1]
                  ? imgDetail[imgDetail.length - 1]
                  : MissingImage?.src
              )
            }
          })
          variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
          variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
          if (variantImageURLs.length < 1) {
            variantImageLabels.push(state.selectedSku)
            variantImageURLs.push(MissingImage?.src)
          }
        } else {
          variantImageLabels.push(state.selectedSku)
          variantImageURLs.push(MissingImage?.src)
        }
      }
      imagesData = formatImages(variantImageLabels, variantImageURLs)
      setImagesData(imagesData)
      for (const element of variants) {
        const variantSku = element
        if (state.ctData.masterVariant) {
          let product = {}
          if (variantSku === state.ctData.masterVariant.sku)
            product = state.ctData.masterVariant
          else
            product = state.ctData.variants.find(
              variant => variantSku === variant.sku
            )
          // Get variant prices from CT data
          let priceObj = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode &&
              price.customerGroup?.obj?.key === state.persona
          )
          let mrpObj = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode && !price.customerGroup
          )

          if (!priceObj?.value)
            priceObj = product?.prices?.find(
              price =>
                price.value?.currencyCode === currencyCode &&
                !price.customerGroup
            )
          pricesData[variantSku] = Number(
            ((mrpObj?.value?.centAmount ?? 0) / 100).toFixed(2)
          )
          setPricesData(pricesData)

          if (
            discountedPrices[variantSku] === 0 ||
            !discountedPrices[variantSku]
          ) {
            discountedPrices[variantSku] = Number(
              ((priceObj?.value?.centAmount ?? 0) / 100).toFixed(2)
            )
            // Pricing Change
            // discountedPrices[variantSku] = Number(
            //   ((priceObj?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2)
            // )
            setDiscountedPrices(discountedPrices)
            if (
              priceObj?.discounted?.discount?.obj?.value.type === "absolute"
            ) {
              discountPercent[variantSku] = Number(
                (priceObj?.discounted?.discount?.obj?.value?.money[0]
                  ?.centAmount ?? 0) / 100
              )
              setDiscountPercent(discountPercent)
              isType[variantSku] = "absolute"
              setIsType(isType)
            } else {
              let salePrice = 0
              if (priceObj?.discounted?.value) {
                salePrice = Number(priceObj?.discounted.value.centAmount)
              } else {
                salePrice = Number(priceObj?.value.centAmount)
              }
              discountPercent[variantSku] = Number(
                ((Number(mrpObj?.value.centAmount) - salePrice) /
                  Number(mrpObj?.value.centAmount)) *
                  100
              ).toFixed()

              setDiscountPercent(discountPercent)
              isType[variantSku] = "relative"
              setIsType(isType)
            }
          }
          const listPrice = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode &&
              !price?.customerGroup?.obj?.key
          )
          listPrices[variantSku] = Number(
            ((listPrice?.value?.centAmount ?? 0) / 100).toFixed(2)
          )
          setListPrices(listPrices)
          // Check if variant is a Combo SKU
          comboSku[variantSku] = product?.attributes.find(
            attr => attr.name === "ComboSKU"
          )
            ? true
            : false
          setComboSku(comboSku)
          // check if product is fragile
          const fragile =
            product?.attributes?.filter(attr =>
              Object.values(attr)?.includes("Fragile")
            )?.length !== 0
          setIsFragile(fragile)
          // Check if Service Part have replacement suggestion
          if (authorData.ctRecommendations) {
            if (0 in authorData.ctRecommendations) {
              partReplacementSuggestions[variantSku] = _get(
                product?.attributes.find(
                  attr =>
                    attr.name === authorData.ctRecommendations[0].fieldname
                ),
                "value",
                ""
              )
              setPartReplacementSuggestions(partReplacementSuggestions)
            }
          }
        }
      }
      const selectedColor = _get(
        colorsData.find(item => item.id === state.selectedSku),
        "label",
        ""
      )
      const pdprops = {
        sku: state.selectedSku,
        customerFacingSKU: customerSkus[state.selectedSku],
        name: isParts
          ? _get(state.productDetailData, "productName_s", "")
          : _get(
              state.productDetailData,
              "ProductBrandName_s",
              _get(state.productDetailData, "productName_s", "")
            ),
        desc: _get(
          state.productDetailData,
          "ProductDescriptionProductShort_s",
          _get(state.productDetailData, "title_s", "")
        ),
        narrativeDescription: _get(
          state.productDetailData,
          "ProductNarrativeDescription_s",
          ""
        ),
        customerBrandName: _get(
          state.productDetailData,
          "CustomerFacingBrand_s",
          ""
        ),
        currencySign: currencySign,
        allVariantDiscotinuedProduct: _get(
          state.productDetailData,
          "productRegionAllVariantDiscontinued_b",
          false
        ),
        ProductRequiredAccessoriesGroupsList: _get(
          state.productDetailData,
          "ProductProductRecommendedAccessories_ss",
          []
        ),
        stickyHeaderProps: {
          productSku: state.selectedSku,
          title: isParts
            ? _get(state.productDetailData, "productName_s", "")
            : _get(
                state.productDetailData,
                "ProductBrandName_s",
                _get(state.productDetailData, "productName_s", "")
              ),
          description: _get(
            state.productDetailData,
            "ProductDescriptionProductShort_s",
            ""
          ),
          itemStatus: "available",
          color: {
            label: selectedColor,
            url: _get(
              colorsData.find(item => item.id === state.selectedSku),
              "colorUrl",
              ""
            ),
          },
        },
        requiredItems: requiredItemstoInstall ?? [],
        productOnStock: state.availableStock,
        colorsData: colorsData,
        addToCartProps: {
          compareChecked: Boolean(
            comparedProducts.find(
              prod => state.masterSku === prod["masterSKU_s"]
            )
          ),
          backOrder: _get(state.productDetailData, "RegionOnBackOrder_s", "No"),
          specialOrder: _get(
            state.variantData.find(item => item.sku_s === state.selectedSku),
            "RegionSpecialOrder_s",
            "No"
          ),
        },
        detailsProps: {
          length: _get(
            state.productDetailData,
            "ProductOverallLengthInches_s",
            0
          ),
          width: _get(
            state.productDetailData,
            "ProductOverallWidthInches_s",
            0
          ),
          height: _get(
            state.productDetailData,
            "ProductOverallHeightInches_s",
            0
          ),
          dimensionUnit: "in",
          detailsData: _get(
            state.productDetailData,
            "ProductWebFeatures_ss",
            []
          ),
        },
        ProductPriceSpiderIncluded_s:
          state.productDetailData?.ProductPriceSpiderIncluded_s === "true"
            ? true
            : false,
        isProjectPack: state.productDetailData["SKUIsProjectPack_s"] === "Yes",
        freightPolicyType: _get(
          state.productDetailData,
          "ProductFreightPolicyType_s",
          ""
        ),
        isFavorite:
          !_isEmpty(favorites) &&
          favorites?.lineItems.find(vl => vl.productId === state.ctData.id)
            ? true
            : false,
        favItem: favorites?.lineItems ?? [],
        ctData: state.ctData.id,
        isFragile: isFragile,
        isRegionSoldOnline: _get(
          state.productDetailData,
          "RegionSoldOnline_b",
          true
        ),
        superSku: superSku,
        loadShowEvent: cartLoaded || state.loadShowEvent, // this should set to true at least once
        cart: cart,
        clickedProductVariant: state.clickedProductVariant,
        selectedColor: selectedColor,
        globalDiscount: Number(
          (
            pricesData[state.selectedSku] -
            _get(
              state.productDetailData,
              `priceList.${state.persona}.finalPrice_d`,
              pricesData[state.selectedSku]
            )
          ).toFixed(2)
        ),
        productSaleable: true,
        productPartnerBuyNow: false,
        productType: _get(state.productDetailData, "ctProductType_s", ""),
        ...state.productDetailData,
      }
      if (
        pdprops.ProductPriceSpiderIncluded_s ||
        isDisContinuedColor ||
        pdprops.isRegionSoldOnline
      ) {
        if (pdprops.ProductPriceSpiderIncluded_s) {
          pdprops.productPartnerBuyNow = true
        }
        pdprops.productSaleable = false
      }

      setPdprops(pdprops)

      const excludedStates = _get(
        state.variantData.find(item => item.sku_s === state.selectedSku),
        "RegionStatesExcluded_ss",
        []
      )
      setExcludedStates(excludedStates)
      // Get badge values for product
      const shipmentDate = _get(
        state.productDetailData,
        "RegionReleaseforShipment_dt",
        ""
      )
      const badgesProps = {
        isNewProduct: showNewBadge(shipmentDate),
        badgeVal: _get(
          state.productDetailData,
          `priceList.${state.persona}.saleOffer_s`,
          ""
        ),
        exclusiveBadge: _get(
          state.productDetailData,
          "ProductIsExclusive_s",
          ""
        ),
      }
      setBadgesProps(badgesProps)
      const { presetConfigs = "{}" } = authorData ?? { presetConfigs: "{}" }
      const presetConfigObject = JSON.parse(presetConfigs)
      setPresetConfigObject(presetConfigObject)
    }
  }, [
    state.productDetailData,
    state.selectedSku,
    state.persona,
    state.variantData,
    state.ctData,
    state.loadShowEvent,
    state.clickedProductVariant,
    state.availableStock,
    state.persona,
    favorites,
  ])

  useEffect(() => {
    if (state.selectedSku) {
      const sku = state.selectedSku
      getAvailableStock(sku)
      dispatch(setPDP({ sku }))
    }
  }, [state.selectedSku])

  const updateImageClickCounter = () => {
    const { imageClickCounter } = state
    setState(prevState => {
      return {
        ...prevState,
        imageClickCounter: imageClickCounter + 1,
      }
    })
  }

  const setSkuVariant = sku => {
    sku &&
      setState(prevState => {
        return {
          ...prevState,
          selectedSku: sku,
          isProductVariantClicked: true,
          clickedProductVariant: false,
        }
      })
    const url = new URL(window.location.href)
    const searchParams = url.searchParams
    const skuNumber = searchParams.get("skuNumber")
    skuNumber
      ? searchParams.set("skuNumber", sku)
      : searchParams.set("skuId", sku)
    const query = "?" + searchParams.toString()
    window.history.replaceState(window.location.pathname, document.title, query)
    dispatch(setPDP({ sku }))
  }

  const formatImages = (labels, urls) => {
    const images = []
    if (authorData) {
      for (let i = 0; i < urls.length; i++) {
        const urlPaths = urls[i].split("?")[0]?.split("/")
        const assetId = urlPaths[urlPaths.length - 1]
        images.push({
          label: labels[i] ?? "",
          assetId,
          url: urls[i] ?? "",
        })
      }
    }
    return images
  }

  const addRequiredItems = list => {
    setState(prevState => {
      return {
        ...prevState,
        reqCartData: list,
      }
    })
  }

  const addToCart = async (items, cb = () => {}, showPreview = true) => {
    let totalAdded = 0
    let products = [
      ...items,
      ...attachWarehouseData(
        state.reqCartData?.map(p => ({
          ...p,
          section: productSections.MUST_ORDER,
        })),
        items[0]
      ),
    ]

    products.forEach(item => {
      if (item.isBundle && item.isInstallService) {
        return (totalAdded += item.quantity * 2)
      }
      return (totalAdded += item.quantity)
    })

    const itemCountMessage =
      totalAdded === 1
        ? `${totalAdded} ${t("kf.pdp.label.itemAdded")} `
        : `${totalAdded} ${t("kf.pdp.label.itemsAdded")} `
    const ToasterMssg = `<a href=${cartUrl}>${itemCountMessage} ${t(
      "kf.pdp.label.yourCart"
    )}</a>`
    const callbackFun = data => {
      const { res: { lineItems = [] } = {} } = data
      if (lineItems.length > 0) {
        if (!_isEmpty(authorData)) {
          const { hapticFeedbackTimer = 0 } = authorData
          window.navigator.vibrate(Number(hapticFeedbackTimer))
        }
      }
      if (isMobile && showPreview) {
        dispatch(
          showToast({
            message: ToasterMssg,
            isVisible: true,
          })
        )
      }
      if (!showPreview) {
        setLoadingMessage("Redirecting to checkout page...")
      }
      cb()
    }

    addToCartFunc(products, showPreview, "", obj => {
      setAtcLoading(false)
      callbackFun(obj)
      document.dispatchEvent(stopATCLoading)
    })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        //cartPrerender()
        setAtcLoading(false)
      })
  }

  const showToaster = mssg => {
    dispatch(
      showToast({
        message: mssg,
        isVisible: true,
      })
    )
    setTimeout(
      () =>
        dispatch(
          showToast({
            message: mssg,
            isVisible: false,
          })
        ),
      3000
    )
  }

  const fetchSkuFromUrl = () => {
    setState(prevState => {
      return {
        ...prevState,
        selectedSku: skuId ? skuId : state.selectedSku,
      }
    })
  }

  useEffect(() => {
    if (
      (collapseBrandNameDisplay || brandNameDisplay) &&
      category &&
      brandName &&
      state.productDetailData &&
      state.productDetailData["ProductPriceSpiderIncluded_s"] !== "true" &&
      state.productDetailData["Product_Category"] &&
      state.productDetailData["isCollapsedPDP_b"]
    ) {
      // Options selector can be enabled in future if any product has the required data
      // getOptions()
    }
  }, [
    collapseBrandNameDisplay,
    brandNameDisplay,
    category,
    brandName,
    state.productDetailData,
  ])

  // Get list of available options to be shown under Select More Options
  const getOptions = async () => {
    const { data } = await apim.get(`/search/plp`, {
      params: {
        fl: "Super_Sku",
        q: "*:*",
        fq: [
          `${
            collapseBrandNameDisplay
              ? "Collapse_Field_s"
              : "ProductBrandNameDisplay_s"
          }:("${collapseBrandNameDisplay ?? brandNameDisplay}")`,
          `ProductLocalCategory_s:("${category}")`,
          '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:[* TO NOW])',
          '-ProductIsRetail:("true")',
          '-ATTR_SPEC_TankLocks_s:("Yes")',
          '-SKUIsProjectPack_s:"Yes"',
        ],
        profilename: `profile_${brandName.toLowerCase()}_PDP`,
        collections: brandName.toLowerCase(),
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat", encode: false })
      },
    })

    const curOptions = {}
    if (data?.facet_counts?.facet_fields) {
      const facets = data.facet_counts.facet_fields ?? {}

      // This request is required to fetch current product options
      const {
        data: {
          response: { docs: optionsData },
        },
      } = await apim.post(`search/pdp/${slug}`, {
        q: "*:*",
        fl: Object.keys(data.fusion?.facet_labels)
          .map(key => key)
          .join(","),
        collections: isParts ? "service_parts" : brandName?.toLowerCase(),
        profilename: isParts
          ? `profile_service_parts_PDP`
          : `profile_${brandName.toLowerCase()}_PDP`,
        search_type: "product_options",
      })

      delete facets["New_Products"]
      delete facets["Available_Now"]
      delete facets["Product_Family"]
      delete facets["Product_Category"]
      delete facets["Color"]
      delete facets["Finish"]
      delete facets["Color.Finish"]

      Object.entries(facets).map(facet => {
        if (facet[1].length <= 2) {
          delete facets[facet[0]]
        }
      })
      Object.entries(facets).map(facet => {
        if (optionsData[0][facet[0]]) {
          curOptions[facet[0]] = optionsData[0][facet[0]] ?? ""
        }
      })
      setState(prevState => {
        return {
          ...prevState,
          options: facets,
          currOptions: curOptions,
          facetLabels: data.fusion?.facet_labels ?? [],
        }
      })
    }

    const payload = { brandName }
    dispatch(getPdpTooltip(payload))
      .unwrap()
      .then(res => {
        const tooltipData = res ?? {}
        setState(prevState => {
          return { ...prevState, selectMoreTooltipData: tooltipData }
        })
      })
  }

  // Search for product variant based on selected option and redirect to that PDP
  const selectOption = async (value = "", facet) => {
    const { options, currOptions } = state
    let slug = ""
    let skuIdMaster = ""
    let bq = ""
    Object.entries(options).map(f => {
      if (f[0] !== facet && currOptions[f[0]]) {
        bq = bq + `${f[0]}:"${currOptions[f[0]]}"^50 `
      }
    })
    if (bq) {
      bq = `(${bq.trim()})`
    }
    const { data } = await apim.get(`/search/plp`, {
      params: {
        fl: "Super_Sku, slug_s,masterSKU_s",
        q: "*:*",
        fq: [
          `${
            collapseBrandNameDisplay
              ? "Collapse_Field_s"
              : "ProductBrandNameDisplay_s"
          }:("${collapseBrandNameDisplay ?? brandNameDisplay}")`,
          `${facet}:("${value.replace(/"/g, '\\"')}")`,
          `ProductLocalCategory_s:("${category}")`,
          '-(productRegionAllVariantDiscontinued_b:("true") OR RegionDiscontinuedDate_dt:[* TO NOW])',
          '-ProductIsRetail:("true")',
          '-ATTR_SPEC_TankLocks_s:("Yes")',
          '-SKUIsProjectPack_s:"Yes"',
        ],
        profilename: `profile_${brandName.toLowerCase()}_PDP`,
        collections: brandName.toLowerCase(),
        ...(bq ? { bq } : {}),
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat", encode: false })
      },
    })

    const groupedSlug = _get(
      data,
      "grouped.Product_Family.groups[0].doclist.docs[0].slug_s",
      ""
    )
    slug = groupedSlug ? groupedSlug : _get(data, "response.docs[0].slug_s", "")
    skuIdMaster = _get(data, "response.docs[0].masterSKU_s", "")

    if (slug) {
      let pdpUrlTmp = await getPDPUrl(category, slug)
      pdpUrlTmp =
        pdpUrlTmp +
        (pdpUrlTmp.indexOf("?") > -1 ? "&" : "?") +
        "skuId=" +
        skuIdMaster

      router.push(pdpUrlTmp)
    }
  }

  const seeAvailableColor = () => {
    setSkuVariant(availableColorFirstSku)
    dispatch(getDiscontinuedProductValue(""))
  }

  const getZipCode = (userZipCode, handleZipCodeAvailabilityCallBack) => {
    checkUserZipCode(userZipCode, handleZipCodeAvailabilityCallBack)
  }

  const getAvailableStock = async sku => {
    try {
      const stock = await getStock(sku)
      setState(prevState => {
        return {
          ...prevState,
          availableStock: stock,
        }
      })
    } catch (err) {
      console.error(
        "Error | getStock | getAvailablesStock | ProductDetails | ",
        err
      )
    }
    setState(prevState => {
      return {
        ...prevState,
        loadShowEvent: true,
        clickedProductVariant: state.isProductVariantClicked,
      }
    })
  }

  const getServiceData = async () => {
    let designServiceSkus = []
    let installationServiceSkus = []
    if (!_isEmpty(state.designServiceDataFromProp)) {
      designServiceSkus = state.designServiceDataFromProp.map(product => {
        if (product.sku) {
          return product.sku
        }
      })
    }
    if (!_isEmpty(state.installationDataFromProp)) {
      installationServiceSkus = state.installationDataFromProp.map(list => {
        if (list.sku) {
          return list.sku
        }
      })
    }

    if (
      designServiceSkus.length === 0 &&
      installationServiceSkus.length === 0
    ) {
      setState(prevState => ({ ...prevState, ctLoading: false }))
      return
    }

    const payload = {
      slug,
      skus: [...designServiceSkus, ...installationServiceSkus],
    }

    dispatch(getProductBySlugAndSku(payload))
      .unwrap()
      .then(productServices => {
        const installationServices = [...productServices].filter(product =>
          installationServiceSkus.includes(product?.masterVariant?.sku)
        )

        const designServices = [...productServices].filter(product =>
          designServiceSkus.includes(product?.masterVariant?.sku)
        )

        const ctData = [...productServices].filter(
          product =>
            !installationServiceSkus.includes(product?.masterVariant?.sku) &&
            !designServiceSkus.includes(product?.masterVariant?.sku)
        )
        const productId = ctData?.[0]?.id
        const productName = ctData?.[0]?.name?.["en-IN"]
        dispatch(
          setProductId({ productId: productId, productName: productName })
        )
        if (ctData?.[0]?.reviewRatingStatistics) {
          setReviews(ctData?.[0].reviewRatingStatistics)
          const reviewObject = {
            reviews: ctData?.[0]?.reviewRatingStatistics,
          }
          dispatch(setReviewDetails(reviewObject))
        }
        setState(prevState => {
          return {
            ...prevState,
            designServiceData: designServices,
            installationData: installationServices,
            ctData: ctData.length > 0 ? ctData[0] : {},
            ctLoading: false,
          }
        })

        if (installationServices.length > 0) {
          getUserLocation()
        }
      })
      .catch(err => {
        setState(prevState => {
          return { ...prevState, ctLoading: false }
        })
      })
  }

  const getUserLocation = () => {
    getLocationByCookies().then(getLocation => {
      const userZipCode = getLocation.zipcode ?? ""
      checkUserZipCode(userZipCode)
    })
  }

  const checkUserZipCode = (userZipCodeVal, callBack) => {
    const newCodes = []
    state.zipCodeData.map(codes => {
      Object.keys(codes).forEach(key => {
        newCodes.push(codes[key].includes(userZipCodeVal))
      })
    })
    const isNearest = newCodes.find(result => result === true) ? true : false
    callBack && callBack(isNearest)
  }

  const removeVariantSelection = () => {
    setState(prevState => {
      return {
        ...prevState,
        clickedProductVariant: false,
        isProductVariantClicked: false,
      }
    })
  }

  const handleBuyNow = items => {
    setBuyNowLoading(true)
    setLoadingMessage("Preparing your cart...")
    const atc = cb => {
      addToCart(items, cb, false)
    }
    initBuyNow(atc)
  }

  if (
    !_isEmpty(state.productDetailData) &&
    !state.viewLoader &&
    (pdprops.name || pdprops.desc) &&
    (discountedPrices[state.selectedSku] > 0 ||
      pricesData[state.selectedSku] > 0)
  ) {
    return (
      <>
        <ProductDetailView
          {...pdprops}
          setPincode={setPincode}
          isPdpPropsLoaded={isPdpPropsLoaded}
          persona={state.persona}
          toaster={state.toaster}
          staticTexts={staticTexts}
          options={state.options}
          facetLabels={state.facetLabels}
          curroptions={state.currOptions}
          productCategory={category}
          productServices={productServices}
          isComboSku={comboSku[state.selectedSku]}
          imagesData={[...imagesData, ...videoIds]}
          price={pricesData[state.selectedSku]}
          listPrice={listPrices[state.selectedSku]}
          discountedPrice={discountedPrices[state.selectedSku] ?? 0}
          discountPercent={discountPercent[state.selectedSku] ?? 0}
          isType={isType[state.selectedSku]}
          setSkuVariant={setSkuVariant}
          selectoption={selectOption}
          getStock={() => getStock(state.selectedSku)}
          onAddToCart={(cartValue, cb = () => {}) => addToCart(cartValue, cb)}
          onAddToCompare={() =>
            addToCompareProduct(
              state.selectedSku,
              pdprops.addToCartProps?.backOrder
            )
          }
          onRemoveFromCompare={() =>
            removeFromCompareProduct(state.selectedSku)
          }
          checkProductCategory={() =>
            checkProductCategory(productCategory, category)
          }
          comparedProductsCount={comparedProducts.length}
          compare={compare}
          isEnable={isEnable}
          isParts={isParts}
          findProPagePath={findProPagePath}
          locale={locale}
          currencySign={currencySign}
          currencyCode={currencyCode}
          addItemsToCart={addRequiredItems}
          showToaster={showToaster}
          onAvailableColor={() => seeAvailableColor()}
          overSizedType={overSizedType}
          cart={cart}
          getZipCode={getZipCode}
          servicesData={state.servicesData}
          installationData={state.installationData}
          designServiceData={state.designServiceData}
          installationDataFromProp={state.installationDataFromProp}
          designServiceDataFromProp={state.designServiceDataFromProp}
          findStoreUrl={findStoreUrl}
          promoTitle={state.promoTitle}
          promoDescription={state.promoDescription}
          enablePromo={state.enablePromo}
          getDiscontinuedProductValue={getDiscontinuedProductValue}
          selectMoreTooltipData={state.selectMoreTooltipData}
          badgesProps={badgesProps}
          viewLoader={state.viewLoader}
          findInstallerPath={getShortenedUrlwithGeneral(
            state.findInstallerPath,
            general
          )}
          removeVariantSelection={removeVariantSelection}
          excludedState={getShippingLocations(state.statesData, excludedStates)}
          mboxes={state.mboxes}
          pdpJson={authorData}
          presetConfigObject={presetConfigObject}
          setProductInfo={data => dispatch(setProductInfo(data))}
          partReplacementSuggestions={
            partReplacementSuggestions[state.selectedSku]
          }
          updateImageClickCounter={updateImageClickCounter}
          imageClickCounter={state.imageClickCounter}
          getReqItemLwData={query =>
            dispatch(getReqItemLwData({ query, brandName }))
          }
          productData={state.productDetailData}
          replaceAddToCart={Boolean(authorData.replaceAddToCart)}
          disableRatings={Boolean(authorData.disableRatings)}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink ?? findStoreUrl}
          linkNewTab={Boolean(authorData.linkNewTab)}
          replaceAddToCartCtaLabel={
            authorData.replaceAddToCartCtaLabel ??
            t("kf.global.label.findStore")
          }
          disableEcommerce={Boolean(authorData.disableEcommerce)}
          fusionQueryId={state.fusionQueryId}
          docId={state.productDetailData.id}
          config={config}
          assetAccountName={assetAccountName}
          homePagePath={homePagePath}
          initialImgAlt={initialImgAlt}
          initialImgUrl={initialImgUrl}
          waterSenseProduct={pdpData["ProductWaterSense_ss"] || []}
          isInstock={pdpData["productIsInStock_b"] || false}
          ctLoading={state.ctLoading}
          atcLoading={atcLoading}
          productCollectionsName={pdpBrnadName}
          businessUnitName={productRoom}
          handleBuyNow={handleBuyNow}
          buyNowLoading={buyNowLoading}
          loadingMessage={loadingMessage}
          reviews={reviews}
          upSellData={upSellData}
        />
      </>
    )
  }
  return (
    <PDPLoader
      pdpJson={authorData}
      pdpData={pdpData}
      skuId={skuId}
      initialImgAlt={initialImgAlt}
      initialImgUrl={initialImgUrl}
    />
  )
}

export default ProductDetail
